export type BrowserHint = "safari" | "chrome";

export interface DownloadSupport {
  isDownloadRestricted: boolean;
  browserHint: BrowserHint | null;
}

/** In-app browser of the Google app (GSA), where programmatic downloads fail. */
export const isGoogleAppUA = (userAgent: string): boolean =>
  userAgent.toLowerCase().includes("gsa/");

/** Android WebView (`; wv` marker), where programmatic downloads fail. */
export const isAndroidWebViewUA = (userAgent: string): boolean =>
  userAgent.toLowerCase().includes("; wv");

/** iOS-family platform (iPhone, iPad, iPod) per UA string. */
export const isIOSPlatformUA = (userAgent: string): boolean =>
  /iphone|ipad|ipod/i.test(userAgent);

export const detectDownloadSupport = (userAgent: string): DownloadSupport => {
  const isDownloadRestricted =
    isGoogleAppUA(userAgent) || isAndroidWebViewUA(userAgent);
  const browserHint = isDownloadRestricted
    ? isIOSPlatformUA(userAgent)
      ? "safari"
      : "chrome"
    : null;
  return { isDownloadRestricted, browserHint };
};

/**
 * Builds an Android `intent://` URL that forces the link to open in Chrome,
 * with a browser fallback URL for non-Chrome handlers.
 */
export const buildAndroidChromeIntentUrl = (currentUrl: string): string => {
  const url = new URL(currentUrl);
  const target = url.host + url.pathname + url.search;
  const scheme = url.protocol.replace(":", "");
  const fallback = encodeURIComponent(currentUrl);
  return `intent://${target}#Intent;scheme=${scheme};package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
};
